import React from "react"
import { Text } from "@/elements"

interface Props {
  isEditing: boolean
  toggleEdit: (isEditing: boolean) => void
}

export const EditingBanner: React.FC<Props> = ({ isEditing, toggleEdit }) => {
  const onClickDone = () => {
    toggleEdit(false)
  }

  if (!isEditing) return null

  return (
    <div className="flex flex-row items-center justify-between bg-fg-1 py-4 pl-4 pr-2">
      <Text variant="body2" className="py-2 text-bg-2">
        You are in editing mode
      </Text>
      <div className="group cursor-pointer px-2 py-2" onClick={onClickDone}>
        <Text variant="body2" className="text-bg-2 group-hover:text-bg-1">
          Done
        </Text>
      </div>
    </div>
  )
}
